import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import newdigi from "../../Assets/newdigi.jpeg";
import "./digital.css";

const Digital = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="Digital-container">
                <div className="Digital-topic">
                    <h1 className="digi-topic">Digital Marketing</h1>
                </div>
                <div className="def">
                    <span className="def-content">Digital marketing is the promotion of products, services, or brands using online channels such as search engines, social media, email, and websites.
                        It involves strategies like SEO, content marketing, PPC advertising, and social media marketing to reach and engage target audiences. Digital marketing helps businesses increase visibility,
                        drive traffic, and boost conversions through data-driven insights and personalized campaigns.
                    </span>
                </div>
                <div className="DM-benefits" style={{marginLeft:"4%"}}>
                    <h2 className="DM-question">Benefits of Digital marketing:-</h2>
                    <div className="fullDM-content">
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column" }}>Digital marketing offers several benefits for businesses and individuals,
                            making it a powerful tool for growth and engagement. Here are some of the key effects and advantages:
                            <ul className="ul-points">
                                <li className="point">Increased Reach & Global Audience– Businesses can reach customers worldwide, breaking geographical barriers.
                                    Online presence allows 24/7 accessibility to products and services.</li>
                                <li className="point">Cost-Effective Marketing– Compared to traditional marketing (TV, radio, print), digital marketing is often more affordable.
                                    PPC, social media ads, and email marketing provide cost-efficient ways to promote products.</li>
                                <li className="point">Targeted Advertising– Digital marketing tools (Google Analytics, Facebook Insights) track performance in real time.
                                    Businesses can adjust strategies based on data for better ROI (Return on Investment).</li>
                                <li className="point">Automation & Efficiency– AI and automation tools streamline processes (chatbots, email automation).
                                    Saves time and enhances customer experience.</li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "450px" }} className="apps-img" src={newdigi} alt="apps" />
                        </div>
                    </div>
                </div>
                <div className="DM-benefits">
                    <h1 className="DM-nextquestion">Services we provide to upscale your business !</h1>
                    <div className="boxes">
                        <motion.div
                            ref={ref1}
                            initial="hidden"
                            animate={inView1 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0}
                            className="point-box"
                        >
                            <h2 className="point-topic">Meta Ads Campaign & Content creation</h2>
                            <span className="point-content">Services for Meta Ads Campaigns include ad strategy, audience targeting, creative design, campaign management,
                                and performance optimization. Content Creation services involve crafting engaging visuals,
                                compelling copy, and high-quality videos or posts to enhance brand awareness and audience engagement.</span>
                        </motion.div>

                        <motion.div
                            ref={ref2}
                            initial="hidden"
                            animate={inView2 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.3}
                            className="point-box"
                        >
                            <h2 className="point-topic">LinkedIn & YouTube Ads</h2>
                            <span className="point-content">for LinkedIn Ads include B2B targeting, ad copywriting, campaign management, and lead generation optimization.
                                For YouTube Ads, services cover video ad creation,
                                audience targeting, campaign setup, and performance tracking to maximize reach and engagement.</span>
                        </motion.div>

                        <motion.div
                            ref={ref3}
                            initial="hidden"
                            animate={inView3 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.6}
                            className="point-box"
                        >
                            <h2 className="point-topic">TikTok Ads</h2>
                            <span className="point-content">Digital marketing services for TikTok Ads include creative short-form video production,
                                precise audience targeting, and campaign optimization. It focuses on engaging,
                                trend-driven content to maximize reach and conversions. Performance tracking and A/B testing ensure better ad effectiveness.</span>
                        </motion.div>

                        <motion.div
                            ref={ref4}
                            initial="hidden"
                            animate={inView4 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.9}
                            className="point-box"
                        >
                            <h2 className="point-topic">Google SEO & Paid Ads</h2>
                            <span className="point-content">services for Google SEO include keyword research, on-page and off-page optimization,
                                technical SEO, and content strategy to improve organic rankings. Google Paid Ads services cover campaign setup,
                                keyword targeting, ad copy creation, bid management, and performance tracking to maximize ROI and conversions.</span>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Digital;